<template>
    <v-container v-resize="onResize">
        <v-layout row wrap align-center>
            <v-flex xs12 md6>
                <h1>Elections</h1>
            </v-flex>
            <v-flex xs12 offset-md2 md4>
                <div>
                    <v-text-field :class="{mobileTextField: isMobile}" v-if="!this.loading" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by:</v-subheader>
                            <v-list-tile v-for="(item, index) in headersWithByElections.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>
        <br />
        <v-layout row wrap align-center justify-space-between>
            <v-flex grow class="handbook-leftDivider_hideSmall">
                <v-btn-toggle v-model="electionTypeSelected" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip v-for="option in electionTypes" :key="option.value" top disabled>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="option.value">
                                <span class="long-button-text chamberButton">{{ option }}</span>
                            </v-btn>
                        </template>
                    </v-tooltip>
                    <span></span>
                </v-btn-toggle>
            </v-flex>
        </v-layout>
        <br />

        <template v-if="electionTypeSelected === 0 || electionTypeSelected === 1">
            <p>Data from the Australian Electoral Commission is added to the online handbook following return of the election writ(s).</p>
            <br />
        </template>

        <loader v-if="loading" />

        <v-data-table v-if="!loading"
                      :headers="headersWithByElections"
                      :items="filteredItems"
                      :disable-initial-sort="true"
                      :search="search"
                      :pagination.sync="PAGINATION"
                      :hide-headers="isMobile"
                      :hide-actions="!isMobile"
                      :rows-per-page-items="ROWS_LISTITEMS"
                      :class="{ mobileDataTable: isMobile, 'elevation-1': true }">
            <template v-slot:items="props">
                <router-link v-if="electionTypeSelected === 0 && isMobile" class="tr" :to="{ name: 'FullElection', params: { year: props.item.Year, electionId: props.item.Id }}">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item">
                                <h3 class="pb-xs-1">{{ props.item.Date | stringDateFormat }}</h3>
                            </div>
                            <div class="flex-item" v-if="props.item.Reps" data-label="House of Representatives Results">
                                <election-result-spark :data="props.item.RepsCounts" :year="props.item.Year"></election-result-spark>
                            </div>
                            <div class="flex-item" v-if="props.item.Senate" data-label="Senate Results">
                                <election-result-spark :data="props.item.SenateCounts" :year="props.item.Year"></election-result-spark>
                            </div>
                        </div>
                    </td>
                </router-link>
                <router-link v-if="electionTypeSelected === 0 && !isMobile" class="tr" :to="{ name: 'FullElection', params: { year: props.item.Year, electionId: props.item.Id }}">
                    <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
                    <td class="text-xs-left">
                        <election-result-spark :data="props.item.RepsCounts" :year="props.item.Year"></election-result-spark>
                    </td>
                    <td class="text-xs-left">
                        <election-result-spark :data="props.item.SenateCounts" :year="props.item.Year"></election-result-spark>
                    </td>
                    <td class="text-xs-left"><v-chip disabled v-if="props.item.Reps" :color="repsColour">House of Representatives</v-chip> <v-chip disabled v-if="props.item.Senate" :color="senateColour">Senate</v-chip></td>
                </router-link>


                <router-link v-if="electionTypeSelected === 1 && isMobile" class="tr" :to="{ name: 'ByElectionResults', params: { year: props.item.Year, electionId: props.item.Id, division: props.item.Division }}">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item">
                                <h3 class="pb-xs-1">{{ props.item.Date | stringDateFormat }}</h3>
                            </div>
                            <div class="flex-item" data-label="Division">
                                {{ props.item.Division }}
                            </div>
                        </div>
                    </td>
                </router-link>
                <router-link v-if="electionTypeSelected === 1 && !isMobile" class="tr" :to="{ name: 'ByElectionResults', params: { year: props.item.Year, electionId: props.item.Id, division: props.item.Division }}">
                    <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
                    <td v-if="props.item.Division" class="text-xs-left">{{ props.item.Division }}
                        <v-chip disabled v-if="!(props.item.Reps || props.item.Senate)" small>Data not yet available</v-chip>
                    </td>
                </router-link>

                <router-link v-if="electionTypeSelected === 2 && isMobile" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}" class="tr handbook-tablerow_link">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item flex-item-col flex-item-col-30">
                                <div class="flex-item">
                                    <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                </div>
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-70">
                                <div class="flex-item">
                                    <h3 class="pb-xs-1">{{ props.item.Name }}</h3>
                                </div>
                                <div class="flex-item" data-label="Date">{{ props.item.Date | stringDateFormat  }}</div>
                                <div class="flex-item" data-label="Party">{{ props.item.Party  }}</div>
                            </div>
                            <div class="flex-item" data-label="Notes">{{ props.item.Notes }}</div>
                        </div>
                    </td>
                </router-link>
                <router-link v-if="electionTypeSelected === 2 && !isMobile" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}" class="tr handbook-tablerow_link">
                    <td class="text-xs-left"><Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait></td>
                    <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                    <td class="text-xs-left">{{ props.item.Party }}</td>
                    <td class="text-xs-left">{{ props.item.Notes }}</td>
                </router-link>
            </template>
        </v-data-table>
        <br />
    </v-container>
</template>

<script>    
    import Loader from '@/components/Loader.vue';
    import ElectionResultSpark from './ElectionResultSpark';
    import axios from 'axios';
    import Portrait from '@/components/Portrait.vue'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        created() {
            this.initialiseItems();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        components: {
            Loader,
            ElectionResultSpark,
            Portrait
        },
        data() {
            return {
                isMobile: false,
                items: [],
                search: '',
                vacancies: [],
                loading: true,
                electionTypeSelected: 0,
                electionTypes: ['Election', 'By-Election', 'Casual Vacancies'],
                HEADERS: [{
                    text: 'Date',
                    value: 'Date',
                    align: 'left',
                    sortable: true
                }],
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    rowsPerPage: -1,
                    sortBy: 'Date',
                    descending: true
                },
            }
        },
        computed: {
            repsColour() {
                return this.$store.state.COLOUR_REPRESENTATIVES
            },
            senateColour() {
                return this.$store.state.COLOUR_SENATE
            },
            filteredItems() {
                switch (this.electionTypeSelected) {
                    case 0:
                        return this.items.filter(i => !i.Division);
                    case 1:
                        return this.items.filter(i => i.Division);
                    case 2:
                        return this.vacancies
                    default:
                        return [];
                }
            },
            headersWithByElections() {
                switch (this.electionTypeSelected) {
                    case 0:
                        return [...this.HEADERS,
                        {
                            text: 'House of Representatives Results',
                            width: '35%',
                            sortable: false,
                        },
                        {
                            text: 'Senate Results',
                            width: '35%',
                            sortable: false,
                        },
                        {
                            text: 'Chamber',
                            value: '',
                            sortable: false
                        }];
                    case 1: 
                        return [...this.HEADERS, 
                        { 
                            text: 'Division',
                            value: 'Division',
                            align: 'left',
                            sortable: true
                        }];
                    case 2:
                        return [
                        {
                            text: '',
                            value: 'Phid',
                            align: 'left',
                            sortable: false,
                        },
                        {
                            text: 'Date',
                            value: 'Date',
                            align: 'left',
                            sortable: true,
                        },
                        {
                            text: 'Name',
                            value: 'Name',
                            align: 'left',
                            sortable: true,
                        },
                        {
                            text: 'Party',
                            value: 'Party',
                            align: 'left',
                            sortable: true,
                        },
                        {
                            text: 'Notes',
                            value: 'Notes',
                            align: 'left',
                            sortable: true,
                        }
                        ]
                    default: return []
                }
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            initialiseItems() {
                this.loading = true;
                const urls = ['Elections/Elections', 'Elections/CasualVacancies']
                Promise.all(urls.map(u => axios.get(`api/${u}`)))
                    .then(([{ data: elections }, { data: vacancies }]) => {
                            this.items = elections;
                            this.vacancies = vacancies.slice().reverse();
                            this.loading = false;

                    })
            },
        },
    }
</script>

<style scoped>
    .v-progress-circular {
        margin: 1rem
    }

    a {
        color: #fff;
        text-decoration: underline;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }

    .v-chip, .v-chip .v-chip__content {
        cursor: pointer !important;
        color: #f5f5f5 !important;
    }
</style>
